import { Component, OnInit } from '@angular/core';
import { UserSessionService } from 'bna-angular-auth-client';
import { filter } from 'rxjs';
import { OrganizationService } from 'src/app/core/services/http/agency-mgmt/organization.service';
import { UserGroupService } from 'src/app/settings/services/user.group.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
})
export class SideNavComponent implements OnInit {
  public readonly maintenanceAppUrl: string;
  public readonly invoiceAutomateUrl: string;
  public invoiceProcessorEnabled = false;
  public maintenanceAppEnabled = false;
  isKeyAutomateEnabled = true;
  isLeadOrgAdmin: boolean = false;
  constructor(
    private userSessionService: UserSessionService,
    private organizationService: OrganizationService,
    private userGroupService: UserGroupService
  ) {
    if (this.userSessionService.isAuthenticated()) this.loadStartupSettings();

    this.userSessionService.isAuthenticated$
      .pipe(filter((d) => d.isAuthenticated))
      .subscribe(() => {
        this.loadStartupSettings();
      });
    this.maintenanceAppUrl = this.userSessionService.addSessionQueryParams(
      `${environment.maintenanceApp.baseUrl}`
    );
    this.invoiceAutomateUrl = this.userSessionService.addSessionQueryParams(
      `${environment.invoiceProcessor.baseUrl}`
    );
  }
  ngOnInit(): void {
  }

  private loadStartupSettings() {
    this.organizationService.getStartupSettings().subscribe((settings) => {
      this.isKeyAutomateEnabled = settings?.isKeyAutomateEnabled;
      this.invoiceProcessorEnabled =
        environment.invoiceProcessor.isEnable &&
        settings?.newInvoiceAutomateAppEnabled &&
        settings?.isCreditCardActivatedOrg;

      this.maintenanceAppEnabled =
        environment.maintenanceApp.isEnable && settings?.isMaintenanceEnabled;
    });
    this.isLeadOrgAdmin = this.userGroupService.isUserLeadOrgAdmin();
  }
}
